import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from '../util/withRouter';

export function getRedirectUrl(props) {
  if (props.dashboards === 0) {
    return '/create';
  }
}

export default function (ComposedComponent) {
  class RequireDashboards extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      if (this.context.router && this.context.router.push) {
          this.context.router.push(to + window.location.search);
      } else if (global.window && window.location) {
          window.location.replace(to + window.location.search);
      }
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const redirectUrl = getRedirectUrl(this.props);
      if (redirectUrl) {
        this.redirect(redirectUrl);
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    const dashboards = state.dashboards.loaded ? state.dashboards.list.length : state.auth.user.dashboards;
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
      dashboards,
    };
  }

  return withRouter(connect(mapStateToProps)(RequireDashboards));
}
